import React from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute, SectionRoute } from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Dashboard from "@/pages/Dashboard";
import Suppliers from "@/pages/Suppliers";
import SupplierDetail from "@/pages/SupplierDetail";
import ProductImport from "@/pages/ProductImport";
import Experiences from "@/pages/Experiences";
import ExperienceDetail from "@/pages/ExperienceDetail";
import Bookings from "@/pages/Bookings";
import BookingDetail from "@/pages/BookingDetail";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import SupportCases from "@/pages/SupportCases";
import SupportCaseDetail from "@/pages/SupportCaseDetail";
import RefundRequests from "@/pages/RefundRequests";
import PaymentsPayouts from "@/pages/PaymentsPayouts";
import Quality from "@/pages/Quality";
import AdminUsers from "@/pages/AdminUsers";
import InviteAccept from "@/pages/InviteAccept";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/accept-invite" element={<InviteAccept />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Overview />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/suppliers" element={<SectionRoute section="suppliers"><Suppliers /></SectionRoute>} />
            <Route path="/suppliers/:id" element={<SectionRoute section="suppliers"><SupplierDetail /></SectionRoute>} />
            <Route path="/product-import" element={<SectionRoute section="suppliers"><ProductImport /></SectionRoute>} />
            <Route path="/experiences" element={<SectionRoute section="experiences"><Experiences /></SectionRoute>} />
            <Route path="/experiences/:id" element={<SectionRoute section="experiences"><ExperienceDetail /></SectionRoute>} />
            <Route path="/bookings" element={<SectionRoute section="bookings"><Bookings /></SectionRoute>} />
            <Route path="/bookings/:id" element={<SectionRoute section="bookings"><BookingDetail /></SectionRoute>} />
            <Route path="/customers" element={<SectionRoute section="customers"><Customers /></SectionRoute>} />
            <Route path="/customers/:id" element={<SectionRoute section="customers"><CustomerDetail /></SectionRoute>} />
            <Route path="/support" element={<SectionRoute section="support"><SupportCases /></SectionRoute>} />
            <Route path="/support/:id" element={<SectionRoute section="support"><SupportCaseDetail /></SectionRoute>} />
            <Route path="/refund-requests" element={<SectionRoute section="refunds"><RefundRequests /></SectionRoute>} />
            <Route path="/payments" element={<SectionRoute section="payments"><PaymentsPayouts /></SectionRoute>} />
            <Route path="/quality" element={<SectionRoute section="reviews"><Quality /></SectionRoute>} />
            <Route path="/admins" element={<SectionRoute section="admins"><AdminUsers /></SectionRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
